import React, { useEffect } from 'react';

const TestResults = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  // Get test result values - same for all models
  const getTestResults = () => {
    const model = formData.model || '';
    
    // Check if model is one of the supported models
    if (model === '4031-OTI' || model === '4031-WTI' || model === '4031H-OTI' || model === '4031H-WTI') {
      return [
        'Indication accuracy found within ±1.5% of FSD',
        'Switch operation is found within ±4℃ of switch setting.',
        'Switch differential accuracy is found within 4±2℃ of settings.',
        'Visual finish found ok.',
      ];
    } else {
      // Default fallback
      return [];
    }
  };

  const defaultResults = getTestResults();

  // Auto-populate test results when model changes
  useEffect(() => {
    if (formData.model && defaultResults.length > 0) {
      const currentResults = formData.testResultsList || [];
      // Only update if the results are different
      if (JSON.stringify(currentResults) !== JSON.stringify(defaultResults)) {
        updateFormData({ testResultsList: defaultResults });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.model]);

  const handleResultChange = (index, value) => {
    const newResults = [...(formData.testResultsList || [])];
    newResults[index] = value;
    updateFormData({ testResultsList: newResults });
  };

  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  const results = formData.testResultsList || defaultResults;

  return (
    <div className="form-section">
      <h3>Test Results & Personnel</h3>
      
      <div className="table-container">
        <table className="test-table">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>No.</th>
              <th>Test Results</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{index + 1}</td>
                <td>
                  <textarea
                    value={result || ''}
                    onChange={(e) => handleResultChange(index, e.target.value)}
                    rows="2"
                    style={{
                      width: '100%',
                      border: 'none',
                      textAlign: 'left',
                      background: 'transparent',
                      padding: '4px',
                      resize: 'vertical',
                      fontFamily: 'inherit',
                      fontSize: 'inherit',
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Tested By:</label>
          <input
            type="text"
            value={formData.testedBy}
            onChange={(e) => handleInputChange('testedBy', e.target.value)}
            placeholder="Enter tester name"
          />
        </div>
        <div className="form-group">
          <label>Approved By:</label>
          <input
            type="text"
            value={formData.approvedBy}
            onChange={(e) => handleInputChange('approvedBy', e.target.value)}
            placeholder="Enter approver name"
          />
        </div>
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default TestResults;



